const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M2 6.75A2.75 2.75 0 0 1 4.75 4h14a2.75 2.75 0 0 1 2.75 2.75v11a2.75 2.75 0 0 1-2.75 2.75h-14A2.75 2.75 0 0 1 2 17.75zM14 19V5.5H9.5V19zm1.5 0h3.25c.69 0 1.25-.56 1.25-1.25v-11c0-.69-.56-1.25-1.25-1.25H15.5zM4.75 5.5H8V19H4.75c-.69 0-1.25-.56-1.25-1.25v-11c0-.69.56-1.25 1.25-1.25" clip-rule="evenodd"/></svg>';
export {
  e as w
};
